// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-content {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.reporties-container {
  width: 100%;
  height: 100%;
  border: 1px solid rgb(228, 227, 227);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.upper-heading-reporties {
  width: 100%;
  border-bottom: 1px solid #dcd4d4;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.back-arrow {
  font-size: 20px;
  font-weight: bold;
  position: absolute;
  left: 0;
  margin-left: 10px;
  cursor: pointer;
}

.back-arrow.disabled {
  opacity: 0.3;
  cursor: default;
}

.reporties-heading {
  text-align: center;
  width: 100%;
}

.manager-search-row {
  font-size: 12px;
  /* margin-top: 8px; */
  margin-left: 10px;
  opacity: 0.85;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
}

.manager-breadcrumb {
  display: flex;
  gap: 6px;
  align-items: center;
}

.manager-label {
  font-weight: bold;
  margin-bottom: 17px;
}

.breadcrumb-item {
  cursor: pointer;
  margin-bottom: 17px;
}

.reporties-search {
  margin-bottom: 17px;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 13px;
  width: 220px;
  margin-right: 20px;
}

.upper-heading-reporties h2 {
  text-align: center;
  margin-bottom: 10px;
  font-size: 22px;
  font-weight: bold;
  padding-top: 10px;
}

.filter-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 15px;
}

.filter-section select {
  padding: 6px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  margin-bottom: 12px;
}

.reporties-table-container {
    flex: 1 1;                /* take remaining height */
  min-height: 0;   
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow-y: auto;
  overflow-x: auto;
  margin:  0px 10px 10px 10px;
}

.reporties-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.reporties-table th,
.reporties-table td {
  padding: 4px;
  text-align: center;
  border: 1px solid #ddd;
  font-weight: 500;
}

.reporties-table th {
  background-color: #deecdd;
  position: sticky;
  top: 0;
  font-size: 12px;
  font-weight: bold;
}

.reporties-table tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

.sno-column {
  width: 5%;
}

.reporties-table td {
  font-size: 12px;
}
.left-align-filter {
  justify-content: flex-start !important;
}
select option {
  text-align: center;
}
.emp-name-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-right: 25px;
  cursor: pointer;
}

.emp-name-cell .main-name {
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.emp-name-cell .min-name {
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  margin-right: 5px;
}

.emp-name-cell .sub-id {
  font-size: 11px;
  color: #777;
  margin-top: 2px;
  text-align: center;
  margin-left: 25px;
}
.emp-name-cell.has-children {
  cursor: pointer;
  transition: background-color 0.3s;
}

.emp-name-cell.has-children:hover {
  background-color: #deecdd;
}

.emp-name-cell .right-icon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  font-weight: bold;
  color: hsl(133, 28%, 57%);
  opacity: 0.7;
  transition: 0.2s;
}

.emp-name-cell.has-children:hover .right-icon {
  opacity: 1;
  transform: translateY(-50%) scale(1.1);
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Team/MyTeam/Reporties.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;IACI,SAAO,iBAAiB,0BAA0B;EACpD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC","sourcesContent":[".dashboard-content {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.reporties-container {\n  width: 100%;\n  height: 100%;\n  border: 1px solid rgb(228, 227, 227);\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.upper-heading-reporties {\n  width: 100%;\n  border-bottom: 1px solid #dcd4d4;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.back-arrow {\n  font-size: 20px;\n  font-weight: bold;\n  position: absolute;\n  left: 0;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.back-arrow.disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.reporties-heading {\n  text-align: center;\n  width: 100%;\n}\n\n.manager-search-row {\n  font-size: 12px;\n  /* margin-top: 8px; */\n  margin-left: 10px;\n  opacity: 0.85;\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 40px;\n}\n\n.manager-breadcrumb {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.manager-label {\n  font-weight: bold;\n  margin-bottom: 17px;\n}\n\n.breadcrumb-item {\n  cursor: pointer;\n  margin-bottom: 17px;\n}\n\n.reporties-search {\n  margin-bottom: 17px;\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 13px;\n  width: 220px;\n  margin-right: 20px;\n}\n\n.upper-heading-reporties h2 {\n  text-align: center;\n  margin-bottom: 10px;\n  font-size: 22px;\n  font-weight: bold;\n  padding-top: 10px;\n}\n\n.filter-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.filter-section select {\n  padding: 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  font-size: 14px;\n  margin-bottom: 12px;\n}\n\n.reporties-table-container {\n    flex: 1;                /* take remaining height */\n  min-height: 0;   \n  border: 1px solid #ddd;\n  border-radius: 10px;\n  overflow-y: auto;\n  overflow-x: auto;\n  margin:  0px 10px 10px 10px;\n}\n\n.reporties-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.reporties-table th,\n.reporties-table td {\n  padding: 4px;\n  text-align: center;\n  border: 1px solid #ddd;\n  font-weight: 500;\n}\n\n.reporties-table th {\n  background-color: #deecdd;\n  position: sticky;\n  top: 0;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.reporties-table tbody tr:nth-child(odd) {\n  background-color: #f9f9f9;\n}\n\n.sno-column {\n  width: 5%;\n}\n\n.reporties-table td {\n  font-size: 12px;\n}\n.left-align-filter {\n  justify-content: flex-start !important;\n}\nselect option {\n  text-align: center;\n}\n.emp-name-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  padding-right: 25px;\n  cursor: pointer;\n}\n\n.emp-name-cell .main-name {\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n}\n.emp-name-cell .min-name {\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n  margin-right: 5px;\n}\n\n.emp-name-cell .sub-id {\n  font-size: 11px;\n  color: #777;\n  margin-top: 2px;\n  text-align: center;\n  margin-left: 25px;\n}\n.emp-name-cell.has-children {\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.emp-name-cell.has-children:hover {\n  background-color: #deecdd;\n}\n\n.emp-name-cell .right-icon {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 18px;\n  font-weight: bold;\n  color: hsl(133, 28%, 57%);\n  opacity: 0.7;\n  transition: 0.2s;\n}\n\n.emp-name-cell.has-children:hover .right-icon {\n  opacity: 1;\n  transform: translateY(-50%) scale(1.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
